import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, ChangeEventHandler } from 'react';
import { useEventCallback } from '../../hooks/useEventCallback';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './Checkbox.module.css';
export type CheckboxProps = PropsWithoutChildren<ComponentProps<'label'>> & {
  label: string;
  value: boolean;
  onValueChanged: (value: boolean) => void;
  disabled?: boolean;
};
export const Checkbox: FunctionComponent<CheckboxProps> = React.memo(props => {
  const $ = _c(11);
  const {
    label,
    value,
    onValueChanged,
    className,
    disabled,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const handleChange = useEventCallback(event => {
    const newValue = event.currentTarget.checked;
    if (newValue !== value && !disabled) {
      onValueChanged(newValue);
    }
  });
  const t0 = classes(className, styles.label, disabled ? styles.disabled : null);
  let t1;
  if ($[0] !== disabled || $[1] !== handleChange || $[2] !== value) {
    t1 = <input id="any" name="any" type="checkbox" checked={value} onChange={handleChange} disabled={disabled} className={styles.input} data-testid="Checkbox.Input" />;
    $[0] = disabled;
    $[1] = handleChange;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== label) {
    t2 = <span className={styles.labelText} data-testid="Checkbox.LabelText">{label}</span>;
    $[4] = label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== remainingProps || $[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <label {...remainingProps} className={t0}>{t1}{t2}</label>;
    $[6] = remainingProps;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});